import { withSingleHitMove } from './moveDecorator.js';
import { globalItemDataStore } from '../../OverworldAnimation.js';

/**
 * Custom implementation for Covet move.
 * Steals the defender's held item only if the attacker had no held item at the time
 * of the attack; the item becomes the attacker's held item and the target's held item is removed.
 */
export default class Covet {
    /**
     * Custom move logic for Covet.
     * Gives the defender's held item to the attacker (only if attacker had none) and removes it from the target.
     */
    static customMoveLogic(battleStateMachine, move, attacker, defender) {
        // Covet steals the opponent's held item if:
        // 1. The attacker doesn't have a held item
        // 2. The defender has a held item
        if (!attacker.heldItem && defender.heldItem) {
            const stolenItem = defender.heldItem;
            const stolenItemId = stolenItem.id;
            const stolenItemName = stolenItem.name || globalItemDataStore[stolenItemId]?.name || 'item';

            // Transfer the item from defender to attacker (attacker had no item)
            attacker.heldItem = stolenItem;
            defender.heldItem = null;

            // Add battle text
            battleStateMachine.context.actions.push(
                battleStateMachine.ag.readText(
                    `${attacker.name} stole ${defender.name}'s ${stolenItemName}!`,
                    { delay: 50 }
                )
            );
        }
    }

    /**
     * Sets up battle actions for Covet move
     * Wrapped with single-hit move decorator that handles damage dealing,
     * then executes custom item-stealing logic before completion
     */
    static setUpBattleActions = withSingleHitMove(Covet.customMoveLogic);
}
